import React from 'react';
import ReactCSSTransition from 'react-transition-group/CSSTransition';
import ButtonAction from './ButtonAction';
import Editable from './Editable';
import { Input, InputGroup, Button, ButtonGroup } from 'reactstrap';
import * as warnings from '../constants/ValidationWarnings';
import { newId, getLimitedText } from '../helpers/GenericHelpers';

export default class EditableField extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = this.inititalProps();
  }

  inititalProps() {
    return {
      text: this.props.text || '',
      allowEmpty: this.props.allowEmpty || false,
      valid: true,
      hasNewText: false,
    };
  }

  validator(input) {
    return this.props.validate ? this.props.validate(input) : true;
  }

  handleChange = (e) => {
    const t = e.target.value;
    this.handleValidation(t);
    const val = t.length === 0 ? null : t;

    const emptyNewText = val == null ? true : !!val;
    const newText = this.props.allowEmpty ? emptyNewText : !!val;

    this.setState({
      text: val,
      hasNewText: newText,
    });
  }

  handleValidation = (val) => {
    this.setState({ valid: this.validator(val) });
  }

  handleSubmit = () => {
    if (this.state.valid && this.props.text !== this.state.text) {
      this.props.update(this.props.id, this.props.itemRef, this.state.text);
      return 'submit';
    } else if (this.props.text === this.state.text) {
      return 'clear';
    } else {
      return 'invalid';
    }
  }

  isSubmitDisabled = () => {
    if (!this.state.hasNewText) {
      return true;
    } else {
      return !this.state.valid;
    }
  }

  render() {
    return (
      <Editable
        text={this.props.text}
        submit={this.handleSubmit}
        itemRef={this.props.itemRef}
        submitDisabled={this.isSubmitDisabled()}
        clearDisabled={this.props.clearDisabled}
        editing={this.props.editing}
        limit={this.props.limit ? this.props.limit : undefined}
      >
          <Input
            type={this.props.textarea ? 'textarea' : 'text'}
            name={this.props.itemRef}
            defaultValue={this.state.text || ''}
            onChange={this.handleChange}
            className={this.state.valid ? 'editable-valid' : 'editable-invalid'}
            autoFocus
          />
          <ReactCSSTransition
            classNames="fade"
            timeout={{ enter: 500, exit: 300 }}>
            {!this.state.valid ?
            <div className="feedback">
              {this.props.warning}
            </div> : <div/>}
          </ReactCSSTransition>
        </Editable>
    );
  }
}
